import { render, staticRenderFns } from "./Err.vue?vue&type=template&id=23bc108d&scoped=true&"
import script from "./Err.vue?vue&type=script&lang=js&"
export * from "./Err.vue?vue&type=script&lang=js&"
import style0 from "./Err.vue?vue&type=style&index=0&id=23bc108d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bc108d",
  null
  
)

export default component.exports